import { z } from 'zod';
import { ProjectStatusTransitionActorSchema, ProjectStatusTransitionReasonSchema, } from '../dto/Project.js';
import { ParticipantRecordingPrivacyModeSchema } from '../dto/Config.js';
import { ProjectStatusSchema } from '../dto/common.js';
export const ResearchDataEventBaseSchema = z
    .object({
    source: z.literal('research-data'),
    version: z.literal(1),
    subject: z.string().min(1),
    action: z.string().min(1),
    occurredAt: z.string().datetime(),
})
    .strict();
export const ProjectStatusChangedEventSchema = ResearchDataEventBaseSchema.extend({
    subject: z.literal('research-data.project.status-changed'),
    action: z.literal('status_changed'),
    data: z
        .object({
        transitionId: z.string().guid(),
        projectId: z.string().guid(),
        organizationId: z.string().guid(),
        previousStatus: ProjectStatusSchema,
        currentStatus: ProjectStatusSchema,
        reason: ProjectStatusTransitionReasonSchema.nullable(),
        actor: ProjectStatusTransitionActorSchema,
    })
        .strict(),
}).strict();
export const ProjectCreatedEventSchema = ResearchDataEventBaseSchema.extend({
    subject: z.literal('research-data.project.created'),
    action: z.literal('created'),
    data: z
        .object({
        projectId: z.string().guid(),
        organizationId: z.string().guid(),
    })
        .strict(),
}).strict();
export const ProjectRecordingPrivacyChangedEventSchema = ResearchDataEventBaseSchema.extend({
    subject: z.literal('research-data.project.recording-privacy-changed'),
    action: z.literal('recording_privacy_changed'),
    data: z
        .object({
        projectId: z.string().guid(),
        organizationId: z.string().guid(),
        previousMode: ParticipantRecordingPrivacyModeSchema,
        currentMode: ParticipantRecordingPrivacyModeSchema,
    })
        .strict(),
}).strict();
//# sourceMappingURL=common.js.map